import axios from "axios";

export default function ReceiptShowService(receiptId) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/receipt/" + receiptId,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
